export enum ERROR_CODES {
  COMPANYDATA_NOT_FOUND = 0,
  FRIENDLY_CAPTCHA_VALIDATION_ERROR = 1007,
  USER_DOMAIN_NOT_FOUND = 1018,

  KEY_MGMT_KEY_NOT_FOUND = 1010,

  KEY_IMPORT_FILE_UPLOAD_FILE_SIZE_EXCEEDED = 1002,
  KEY_IMPORT_FILE_UPLOAD_WRONG_FORMAT = 1009,
  KEY_IMPORT_FILE_UPLOAD_EMPTY_FILE = 1011,
  KEY_IMPORT_FILE_UPLOAD_PARSE_ERROR =1012


}

export enum AuthErrorCodes {
  NO_COMPANY_DATA = 999,
  DOMAIN_USAGE = 998,
  USER_NOT_FOUND = 997,
  NO_APP_PERMISSION = 0
}
